import { useNavigate } from 'react-router-dom';

import arrowLeft from '../../../../../assets/svgs/arrow_left-icon.svg';
import { CustomIcon } from '../../../../../components/widgets/CustomIcon';
import { useMediaQuery } from '../../../../../hooks/useMediaQuery';
import { NotificationSideBar } from '../navegation/NotificationSideBar';
import { NotificationLayoutProps } from '../types/notificationTypes';

export const NotificationLayout = ({
  title,
  children
}: NotificationLayoutProps) => {
  const isMobile = useMediaQuery('(max-width: 700px)');
  const navigate = useNavigate();

  return (
    <div className="tw-flex">
      {!isMobile && <NotificationSideBar />}
      <div className="tw-w-screen tw-h-auto">
        <h2 className="tw-bg-[#f0f0f0] tw-px-4 md:tw-px-14 tw-py-7 tw-text-[#000000] tw-text-[1.5rem] md:tw-text-[2rem] tw-font-bold">
          {title}
        </h2>
        <div className="tw-px-4 md:tw-px-14 tw-pb-8">
          <button
            className="tw-mt-22 tw-py-7 tw-underline tw-text-[#001E64] tw-flex tw-gap-2 tw-font-bold tw-cursor-pointer"
            onClick={() => navigate(-1)}
          >
            <CustomIcon
              src={arrowLeft}
              width={isMobile ? 20 : 24}
              height={isMobile ? 20 : 24}
            />
            <p>Voltar</p>
          </button>
          <div className="tw-min-h-[calc(100vh-325px)]">{children}</div>
        </div>
      </div>
    </div>
  );
};
